<template>
  <div v-loading.body="loading">
    <el-row class="shop-data">
      <el-col :span="24">
        <div style="font-size: 14px;">
          {{ generateCustomizeString('dataUpdatedAt') }}:{{ this.nowTime }}
        </div>
        <p style="font-size: 12px; color: red;">
          {{ generateCustomizeString('statisticsNotice') }}
        </p>
      </el-col>
      <el-col :span="24" style="margin-top: 30px;">
        <el-col :span="12">
          <span style="font-size: 16px;">{{
            generateCustomizeString('statisticsDuration')
          }}</span>
          <el-radio-group v-model="time" @change="selectTime">
            <el-radio-button
              :label="generateCustomizeString('thirtydaysSales')"
            ></el-radio-button>
            <el-radio-button
              :label="generateCustomizeString('historicalSales')"
            ></el-radio-button>
          </el-radio-group>
          <el-button
            @click="handleExport"
            style="margin-left:10px"
            type="primary"
            :disabled="is_export_btn_disable"
          >
            {{ generateCustomizeString('exportCurrentData') }}</el-button
          >
          <el-button
            @click="handleExportAll"
            style="margin-left:10px"
            type="primary"
            :disabled="is_export_all_btn_disable"
          >
            {{ generateCustomizeString('exportAllData') }}</el-button
          >
        </el-col>
        <el-col :span="12" style="text-align: right; padding-right: 30px;">
          <el-form ref="searchForm" :inline="true" :model="searchForm">
            <el-form-item :label="generateCustomizeString('searchGoods')">
              <el-input
                v-model="searchForm.name"
                :placeholder="generateCustomizeString('goodsName')"
              ></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 5px;">
              <el-button type="primary" @click="search">{{
                generateCustomizeString('search')
              }}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-col>
      <el-col style="padding: 20px 0 10px 30px;">
        <div style="font-size: 16px; font-weight: bold;">
          {{ generateCustomizeString('basicInformation') }}
        </div>
      </el-col>
      <el-col style="padding-bottom: 100px;">
        <el-table :data="dataDetails" tooltip-effect="dark" style="width: 100%">
          <el-table-column
            prop="barcode"
            :label="generateCustomizeString('barcode')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.bar_code }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="goodsImg"
            :label="generateCustomizeString('goodsImage')"
          >
            <template slot-scope="scope">
              <img :src="scope.row.images" style="width: auto; height: 80px;" />
            </template>
          </el-table-column>
          <el-table-column
            prop="goodsName"
            :label="generateCustomizeString('goodsName')"
            width="400"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.product_name }}</div>
              <div>{{ scope.row.skus }}</div>
              <div>{{ scope.row.brand_name }}</div>
              <div>{{ scope.row.category_name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            :label="generateCustomizeString('merchandisePrice')"
          >
            <template slot-scope="scope">
              <span>NZD ${{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sales"
            :label="generateCustomizeString('salesVolume')"
          >
            <template slot-scope="scope">
              <span v-if="time === '30天销量'">{{
                scope.row.last_30_sales_volume
              }}</span>
              <span v-else>{{ scope.row.sales_volume }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="sales" label="销量" v-else>
            <template slot-scope="scope">
            </template>
          </el-table-column> -->
          <el-table-column
            prop="sort"
            :label="generateCustomizeString('salesRank')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.sort }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            :label="generateCustomizeString('operate')"
          >
            <template slot-scope="scope">
              <el-button
                @click="editClick(scope.row)"
                type="text"
                size="small"
                >{{ generateCustomizeString('edit') }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-col style="margin-top: 10px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[15, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="currentTotal"
          >
          </el-pagination>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
import { generateCustomizeString } from '@/utils/i18n'
import downloadSCV from '@/utils/exportCSV'

const originSearchFrom = {
  name: ''
}

export default {
  name: 'GoodsStatistics',
  data() {
    return {
      is_export_all_btn_disable: true,
      total_rows: null,
      nowTime: '',
      filters: '',
      currentPage: 1,
      currentTotal: 0,
      pageSize: 15,
      time: '30天销量',
      is_export_btn_disable: true,
      orderBy: '',
      dataPicker: '',
      loading: false,
      dataDetails: [],
      searchForm: Object.assign({}, originSearchFrom)
    }
  },
  methods: {
    generateCustomizeString,
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchDataDetails(1)
    },
    handleCurrentChange(val) {
      this.fetchDataDetails(val)
    },
    search() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          // const params = Object.assign({}, this.searchForm)
          this.filters = this.searchForm.name
          this.fetchDataDetails(1)
        } else {
          console.log('data error')
        }
      })
    },
    handleExport() {
      if (this.currentTotal <= 0) {

      } else {
        downloadSCV(this.getCSV_title, this.getCSV_content, `commodity_sales`)
      }
    },
    handleExportAll() {
      if (this.currentTotal <= 0) {
        return
      }
      this.is_export_all_btn_disable = true
      request({
        url: '/stat/board/sales/amount/sku/list',
        method: 'get',
        params: {
          page: 1,
          page_size: this.currentTotal,
          key: this.filters,
          order_by: 'sales_volume'
        }
      }).then(({ data }) => {
        const _data = data.map(
          ({ goods_spu: { product_name }, property_name, price, sales_volume, i }) => {
            return { product_name, property_name, price: (price / 100), sales_volume, i }
          }
        )
        downloadSCV(this.getCSV_title, _data, `all_commodity_sales`)
        this.is_export_all_btn_disable = false
      })
    },
    selectTime() {
      this.fetchDataDetails(1)
    },
    editClick(row) {
      this.$router.push({
        name: 'EditMerchandise',
        params: { goodsId: row.goods_spu_id }
      })
    },
    fetchDataDetails(page) {
      this.is_export_btn_disable = true
      if (this.time === '30天销量') {
        this.orderBy = 'last_30_sales_volume'
      } else {
        this.orderBy = 'sales_volume'
      }
      request({
        url: '/stat/board/sales/amount/sku/list',
        method: 'get',
        params: {
          page: page,
          page_size: this.pageSize,
          key: this.filters,
          order_by: this.orderBy
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          for (var i = 0; i < data.length; i++) {
            const tmp = data[i]
            var obj = {}

            this.keys = Object.keys(tmp.property)
            let result = ''
            for (var j = 0; j < this.keys.length; j++) {
              const key = this.keys[j]
              result += key + ':' + tmp.property[key] + '  '
            }

            if (this.keys[0] !== 'property_default') {
              obj.skus = result
            } else {
              obj.skus = ''
            }
            obj.bar_code = tmp.bar_code
            if (tmp.goods_spu.images.length) {
              obj.images =
                tmp.goods_spu.images[0].image_url +
                '?imageView2/1/w/200/h/200/q/75|imageslim'
            }
            obj.goods_spu_id = tmp.goods_spu_id
            obj.product_name = tmp.goods_spu.product_name
            obj.brand_name = tmp.goods_spu.brand.brand_name
            obj.category_name = tmp.goods_spu.category.name
            obj.price = ((tmp.price / 100) * 1000) / 1000
            obj.last_30_sales_volume = tmp.last_30_sales_volume
            obj.property_name = tmp.property_name
            obj.dataDetails = tmp.dataDetails
            obj.sort = tmp.i
            data[i] = obj
          }
          this.dataDetails = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
          this.is_export_all_btn_disable = false
          this.is_export_btn_disable = false
        })
        .catch(error => {
          console.warn(error)
        })
    }
  },
  computed: {
    getCSV_title() {
      return [
        this.generateCustomizeString('goodsName'),
        this.generateCustomizeString('productProperty'),
        this.generateCustomizeString('merchandisePrice') + '(nzd$)',
        this.time,
        this.generateCustomizeString('salesRank')
      ]
    },
    getCSV_content() {
      return this.dataDetails.map(
        ({ product_name, property_name, price, last_30_sales_volume, sales_volume, sort }) => {
          if (this.time == '30天销量') {
            return { product_name, property_name, price: price.toFixed(2), last_30_sales_volume, sort }
          } else {
            return { product_name, property_name, price: price.toFixed(2), sales_volume, sort }
          }
        }
      )
    }
  },
  created: function() {
    var date = new Date()
    this.nowTime =
      date.getFullYear() +
      '-' +
      (date.getMonth() + 1) +
      '-' +
      date.getDate() +
      ' ' +
      '00:00:00'
    this.fetchDataDetails(1)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.shop-data {
  padding: 30px;
}
.statistics-title {
  padding-left: 10px;
  background-color: #f1f1f1;
  font-size: 16px;
  font-weight: bold;
  line-height: 40px;
  border-bottom: 1px solid #e6e6e6;
}
.statistics {
  border-right: 1px solid #e6e6e6;
  padding: 40px 0 30px 30px;
}
.statistics-number {
  padding-right: 30px;
  line-height: 40px;
  font-size: 24px;
  text-align: right;
}
.shop-chart {
  padding: 20px 30px;
  height: 460px;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-color: #fdfdfd;
}
</style>
<style type="text/css">
.el-input__icon {
  line-height: 20px;
}
</style>
